import { render, staticRenderFns } from "./WorkbookReportPreviewToolbar.vue?vue&type=template&id=c8804a38"
import script from "./WorkbookReportPreviewToolbar.vue?vue&type=script&lang=js"
export * from "./WorkbookReportPreviewToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports